function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hand",
  transform: "translate(73.932 -10.278) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1012",
  "data-name": "Path 1012",
  d: "M898.031,875.3s-39.176-50.291-43.578-53.7-28.782-23.439-23.549-30.152c5-6.412,19.579,11.681,27.714,15.847,6.486,3.321,13.239-.55,27.345-10.087,10.569-7.146,13.673-8.987,15.553-6.578,3.3,4.23-10.631,9.4-9.684,19.123,1.351,13.88,41.524,42.917,41.524,42.917",
  transform: "translate(-830.171 -773.142)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1013",
  "data-name": "Path 1013",
  d: "M927.035,830.719s-10.929-25.876-5.679-28.758c5.044-2.77,23.623,23.109,24.65,44.641",
  transform: "translate(-893.589 -781.713)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1014",
  "data-name": "Path 1014",
  d: "M1007.126,961.386s18.695-13.673,28.085-21.229l9.963,8.6s-20.188,18.113-28.175,25.158Z",
  transform: "translate(-955.198 -879.499)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1015",
  "data-name": "Path 1015",
  d: "M958.017,770.831c2.108-13.845,5.815-19.81,9.443-27.04,2.065-4.115,1.354-12.391-3.786-9.867-10.822,5.315-14.625,23.873-14.625,23.873Z",
  transform: "translate(-914.164 -733.454)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1016",
  "data-name": "Path 1016",
  d: "M1005.98,847.954",
  transform: "translate(-954.388 -814.353)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1017",
  "data-name": "Path 1017",
  d: "M979.608,788.549c.494-9.352,10.824-33.507,13.993-29.593,3.742,4.622-6.713,26.367-6.713,26.367",
  transform: "translate(-935.755 -751.172)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1018",
  "data-name": "Path 1018",
  d: "M997.872,1012.109l9.977,12.648-2.529,2.007a3.521,3.521,0,0,1-4.947-.569l-5.6-7.132a3.521,3.521,0,0,1,.569-4.947Z",
  transform: "translate(-945.931 -930.336)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1019",
  "data-name": "Path 1019",
  d: "M994.011,849.867s5.111-3.514,9.216-2.421",
  transform: "translate(-945.931 -813.846)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.901,
    height: 136.9,
    viewBox: "0 0 136.901 136.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.3e98fed3.svg";
export { ForwardRef as ReactComponent };